import React, { useContext } from "react";
import { Menu, Sun, Moon } from "lucide-react";
import { ThemeContext } from "../../context/ThemeContext";

import "../../style/admin-navbar.css";

export default function AdminNavbar({ setOpen }) {
  const { theme, toggleTheme } = useContext(ThemeContext);

  return (
    <header className="admin-navbar">

      <div className="admin-navbar-left">
        <button className="admin-hamburger" onClick={() => setOpen(true)}>
          <Menu size={22} />
        </button>
        <h1 className="admin-navbar-title">Admin Panel</h1>
      </div>

      <div className="admin-navbar-right">
        <button
          type="button"
          className="admin-theme-btn"
          onClick={toggleTheme}
          title={theme === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"}
          aria-label="Toggle theme"
        >
          {theme === "dark" ? <Sun size={17} /> : <Moon size={17} />}
        </button>
      </div>

    </header>
  );
}

